export default __webpack_public_path__ + "static/vietnam-results-1-52cab52733af77cb5ba6817aac447339.png";